export function withPreventDefault(fn, ...args){
    return (event) => {
        event.preventDefault()
        fn(event, ...args)
    }
}